var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"hot-app"}},[_c('HotTable',{ref:"msgSettingsTable",attrs:{"root":"msgSettingsTable","settings":_vm.settings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }